import classes from './Button.module.css'
const ButtonComponent = ({text, isClickable = true}) => {
    const buttonClasses = isClickable ? `${classes.btn} ${classes.pointer}` : classes.btn;
    return (
        <div className={buttonClasses}>
            <p>{text}</p>
        </div> 
    )
}
export default ButtonComponent;